import {inject, Injectable} from "@angular/core";
import {createStore} from "@ngneat/elf";
import {selectAllEntities, setEntities, withEntities} from "@ngneat/elf-entities";
import {withRequestsCache} from "@ngneat/elf-requests";
import {APIService} from "./api.service";
import {concatMap, Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {IFrequentlyAskedQuestions} from "../interfaces/IFrequentlyAskedQuestions";
import {IAddFrequentlyAskedQuestions} from "../interfaces/IAddFrequentlyAskedQuestions";
import {IEditFrequentlyAskedQuestions} from "../interfaces/IEditFrequentlyAskedQuestions";
import {HttpParams} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FrequentlyAskedQuestionsService {

  private faqsStore = createStore(
    {name: 'all-faqs'},
    withEntities<IFrequentlyAskedQuestions, 'Id'>({idKey: 'Id'}),
    withRequestsCache<'all-faqs'>()
  );

  private apiService: APIService = inject(APIService);

  public selectFaqs$(): Observable<IFrequentlyAskedQuestions[]> {
    return this.faqsStore.pipe(selectAllEntities());
  }

  public fetchAdminAppFaqs(gameId?: string): Observable<IFrequentlyAskedQuestions[]> {
    let params = new HttpParams();
    if (gameId) {
      params = params.append('gameId', gameId);
    }
    return this.apiService.MakeGetRequest<IFrequentlyAskedQuestions[]>('admin-app-faqs', params).pipe(
      tap((res: IFrequentlyAskedQuestions[]) => {
        this.faqsStore.update(setEntities(res));
      })
    );
  }

  public fetchAllFaqs(gameId?: string): Observable<IFrequentlyAskedQuestions[]> {
    let params = new HttpParams();
    if (gameId) {
      params = params.append('gameId', gameId);
    }
    return this.apiService.MakeGetRequest<IFrequentlyAskedQuestions[]>('all-faqs', params).pipe(
      tap((res: IFrequentlyAskedQuestions[]) => {
        this.faqsStore.update(setEntities(res));
      })
    );
  }

  public editWebappFaq(faqP: IEditFrequentlyAskedQuestions) {
    return this.apiService.MakePutRequest(`faq/webapp/edit`, faqP).pipe(concatMap(() => {
      return this.fetchAllFaqs();
    }));
  }

  public addWebappFaq(faqP: IAddFrequentlyAskedQuestions) {
    return this.apiService.MakePostRequest(`faq/webapp/add`, faqP).pipe(concatMap(() => {
      return this.fetchAllFaqs();
    }));
  }

  public editAdminAppFaq(faqP: IEditFrequentlyAskedQuestions) {
    return this.apiService.MakePutRequest(`faq/admin-app/edit`, faqP).pipe(concatMap(() => {
      return this.fetchAllFaqs();
    }));
  }

  public addAdminAppFaq(faqP: IAddFrequentlyAskedQuestions) {
    return this.apiService.MakePostRequest(`faq/admin-app/add`, faqP).pipe(concatMap(() => {
      return this.fetchAllFaqs();
    }));
  }
}
